export default function () {
  return [
    // Dashboard
    {
      title: 'sidebar.menu.dashboard',
      name: 'dashboard',
      to: {
        name: 'admin-overview',
      },
      htmlBefore: '<i class="material-icons">dashboard</i>',
    },
    // Generate
    {
      title: 'sidebar.menu.tools.generate',
      name: 'generate',
      to: {
        name: 'admin-generate-new',
      },
      htmlBefore: '<i class="material-icons">engineering</i>',
    },
    // Break text into lines
    {
      title: 'sidebar.menu.tools.breakText',
      name: 'break-text',
      to: {
        name: 'admin-break-text-new',
      },
      htmlBefore: '<i class="material-icons">text_snippet</i>',
    },
    // Separate words
    {
      title: 'sidebar.menu.tools.wordSeparator',
      name: 'word-separator',
      to: {
        name: 'admin-word-separator-new',
      },
      htmlBefore: '<i class="material-icons">spellcheck</i>',
    },
    // Special Character Remover
    {
      title: 'sidebar.menu.tools.specialCharacterRemover',
      name: 'special-character-remover',
      to: {
        name: 'admin-special-character-remover-new',
      },
      htmlBefore: '<i class="material-icons">auto_fix_normal</i>',
    },
    // Groups words
    {
      title: 'sidebar.menu.tools.wordGroups',
      name: 'word-groups',
      to: {
        name: 'admin-word-groups-new',
      },
      htmlBefore: '<i class="material-icons">bar_chart</i>',
    },
    // Banco de palavras
    {
      title: 'sidebar.menu.words.title',
      name: 'words',
      to: {
        name: 'admin-word-new',
      },
      htmlBefore: '<i class="material-icons">storage</i>',
      items: [
        {
          isAdmin: true,
          title: 'sidebar.menu.words.list',
          to: {
            name: 'admin-word-list',
            params: {
              page: 1,
            },
          },
        },
        {
          isAdmin: true,
          title: 'sidebar.menu.words.import',
          to: {
            name: 'admin-word-list-import',
            params: {
              page: 1,
            },
          },
        },
        {
          isAdmin: false,
          title: 'sidebar.menu.words.add',
          to: {
            name: 'admin-word-new',
          },
        },
      ],
    },
    // Games
    {
      title: 'sidebar.menu.games.title',
      name: 'games',
      htmlBefore: '<i class="material-icons">grid_view</i>',
      items: [
        // Cryptogram Generator
        {
          title: 'sidebar.menu.games.cryptograms.title',
          name: 'cryptogram-generator',
          htmlBefore: '<i class="material-icons">lock</i>',
          to: {
            name: 'admin-cryptogram-list',
            params: {
              page: 1,
            },
          },
          items: [
            {
              title: 'sidebar.menu.games.cryptograms.list',
              to: {
                name: 'admin-cryptogram-list',
                params: {
                  page: 1,
                },
              },
            },
            {
              title: 'sidebar.menu.games.cryptograms.add',
              to: {
                name: 'admin-cryptogram-new',
              },
            },
          ],
        },
        // Cruzadas
        {
          title: 'sidebar.menu.games.crosswords.title',
          name: 'puzzle',
          to: {
            name: 'admin-crossword-list',
            params: {
              page: 1,
            },
          },
          htmlBefore: '<i class="material-icons">extension</i>',
          items: [
            {
              title: 'sidebar.menu.games.crosswords.list',
              to: {
                name: 'admin-crossword-list',
                params: {
                  page: 1,
                },
              },
            },
            {
              title: 'sidebar.menu.games.crosswords.add',
              to: {
                name: 'admin-crossword-new',
              },
            },
            {
              title: 'sidebar.menu.games.crosswords.templates',
              to: {
                name: 'admin-crossword-template-list',
                params: {
                  page: 1,
                },
              },
            },
          ],
        },
        // Hunting Words
        {
          title: 'sidebar.menu.games.huntingWords.title',
          name: 'hunting-words',
          to: {
            name: 'admin-hunting-words-list',
            params: {
              page: 1,
            },
          },
          htmlBefore: '<i class="material-icons">font_download</i>',
          items: [
            {
              title: 'sidebar.menu.games.huntingWords.list',
              to: {
                name: 'admin-hunting-words-list',
                params: {
                  page: 1,
                },
              },
            },
            {
              title: 'sidebar.menu.games.huntingWords.add',
              to: {
                name: 'admin-hunting-words-new',
              },
            },
          ],
        },
        // Shapes Links
        {
          title: 'sidebar.menu.games.shapeLinks.title',
          name: 'shape-links',
          to: {
            name: 'admin-shape-links-list',
            params: {
              page: 1,
            },
          },
          htmlBefore: '<i class="material-icons">category</i>',
          items: [
            {
              title: 'sidebar.menu.games.shapeLinks.list',
              to: {
                name: 'admin-shape-links-list',
                params: {
                  page: 1,
                },
              },
            },
            {
              title: 'sidebar.menu.games.shapeLinks.add',
              to: {
                name: 'admin-shape-links-new',
              },
            },
          ],
        },
        // Loop
        {
          title: 'sidebar.menu.games.loop.title',
          name: 'puzzle-loop',
          to: {
            name: 'admin-puzzle-loop-list',
            params: {
              page: 1,
            },
          },
          htmlBefore: '<i class="material-icons">repeat_on</i>',
          items: [
            {
              title: 'sidebar.menu.games.loop.list',
              to: {
                name: 'admin-puzzle-loop-list',
                params: {
                  page: 1,
                },
              },
            },
            {
              title: 'sidebar.menu.games.loop.add',
              to: {
                name: 'admin-puzzle-loop-new',
              },
            },
          ],
        },
        // numberSquare
        {
          title: 'sidebar.menu.games.numberSquare.title',
          name: 'puzzle-number-square',
          to: {
            name: 'admin-puzzle-number-square-list',
            params: {
              page: 1,
            },
          },
          htmlBefore: '<i class="material-icons">calculate</i>',
          items: [
            {
              title: 'sidebar.menu.games.numberSquare.list',
              to: {
                name: 'admin-puzzle-number-square-list',
                params: {
                  page: 1,
                },
              },
            },
            {
              title: 'sidebar.menu.games.numberSquare.add',
              to: {
                name: 'admin-puzzle-number-square-new',
              },
            },
          ],
        },
        // Fences
        {
          title: 'sidebar.menu.games.fences.title',
          name: 'puzzle-fences',
          to: {
            name: 'admin-puzzle-fences-list',
            params: {
              page: 1,
            },
          },
          htmlBefore: '<i class="material-icons">fullscreen_exit</i>',
          items: [
            {
              title: 'sidebar.menu.games.fences.list',
              to: {
                name: 'admin-puzzle-fences-list',
                params: {
                  page: 1,
                },
              },
            },
            {
              title: 'sidebar.menu.games.fences.add',
              to: {
                name: 'admin-puzzle-fences-new',
              },
            },
          ],
        },
        // Walls
        {
          title: 'sidebar.menu.games.walls.title',
          name: 'puzzle-walls',
          to: {
            name: 'admin-puzzle-walls-list',
            params: {
              page: 1,
            },
          },
          htmlBefore: '<i class="material-icons">density_small</i>',
          items: [
            {
              title: 'sidebar.menu.games.walls.list',
              to: {
                name: 'admin-puzzle-walls-list',
                params: {
                  page: 1,
                },
              },
            },
            {
              title: 'sidebar.menu.games.walls.add',
              to: {
                name: 'admin-puzzle-walls-new',
              },
            },
          ],
        },
        // Puzzle term
        {
          title: 'sidebar.menu.games.term.title',
          name: 'term',
          to: {
            name: 'admin-puzzle-term-list',
            params: {
              page: 1,
            },
          },
          htmlBefore: '<i class="material-icons">view_module</i>',
          items: [
            {
              title: 'sidebar.menu.games.term.list',
              to: {
                name: 'admin-puzzle-term-list',
                params: {
                  page: 1,
                },
              },
            },
          ],
        },
      ],
    },
    // User
    {
      title: 'sidebar.menu.users.title',
      name: 'users',
      to: {
        name: 'admin-user-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">perm_identity</i>',
      items: [
        {
          title: 'sidebar.menu.users.list',
          to: {
            name: 'admin-user-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'sidebar.menu.users.add',
          to: {
            name: 'admin-user-new',
          },
        },
      ],
    },
  ];
}
